/**
 * Аутентификация пользователя проводится по токену (user-token).
 * На каждой стр. делается запрос "GET /current" (метод "tokenAuthenticationRequest") для валидации токена.
 * Токен берется из localStorage или из url-параметра "token". Url-параметр в приоритете.
 *
 */

import store from "@/store/";
import axios from "axios";
import { Route } from "vue-router";

// TODO: refactoring - Добавить сюда tokenAuthenticationRequest()
export const ifNotAuthenticated = (to: Route, from: Route, next: any): any => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/");
};

// TODO: refactoring - Перенести часть логики отсюда в модуль store - auth.
// Возможно вообще всю логику отсюда стоит перенести в store.auth.
export const ifAuthenticated = async (to: Route, from: Route, next: any): Promise<any> => {
  let userToken: string|null = null;
  let allowedPages: string[] = [];

  const localStorageUserToken = localStorage.getItem("lk-user-token");
  const urlUserToken = to.query.token;

  if (Boolean(localStorageUserToken)) {
    userToken = localStorageUserToken;
  }
  if (Boolean(urlUserToken)) {
    userToken = <string> to.query.token;
  }

  // const isAuthenticated: boolean = await tokenAuthenticationRequest(userToken);

  allowedPages = JSON.parse(localStorage.getItem("lk-allowedPages") || "[]");

  if (allowedPages.length > 0) {
    if (to.path !== "/change_password" && store.getters.isNeedChangePassword === true) {
      next("/change_password");
    }
    if (to.meta.msgKey && !allowedPages.includes(to.meta.msgKey)) {
      next("/access_denied")
    }
    next();
  } else {
    next("/login");
  }
};

async function tokenAuthenticationRequest(token: string|null): Promise<boolean> {
  axios.defaults.headers.common["Authorization"] = token === null ? "null" : token;
  try {
    localStorage.setItem("lk-user-token", <string> token);

    const allowedPages = await store.dispatch("getAllowedPages");
    localStorage.setItem("lk-allowedPages", JSON.stringify(allowedPages));

    store.commit('authSuccess', token);
    return true;
  } catch (error) {
    return false;
  }
}